import React, { memo } from "react";
import { FaSearch } from "react-icons/fa";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { FaTrashCan } from "react-icons/fa6";
import styles from "../table.module.scss";
import StatusTab from "./StatusTab";
import PaymentStatusTab from "./PaymentStatusTab";
import { globalStatusChange } from "../../../../store/slices/tableStatusChange";
import { setPaymentStatus } from "../../../../store/slices/tablePaidStatus";
import { useDispatch } from "react-redux";

const ActionButtons = ({
  canAdd,
  handleAddBtn,
  canExport,
  handleExportData,
  searchValue,
  handleSearch,
  addModal,
  setBulkUploadModal,
  showPaymentStatusTab = false,
  hideStatusTab,
  showLimitDropdown = false,
  limit,
  onLimitChange,
}) => {
  const dispatch = useDispatch();

  return (
    <>
      <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
        {canAdd && handleAddBtn && (
          <button
            className="btn btn-primary btn-rounded me-4"
            onClick={() => addModal(true)}
          >
            + Add
          </button>
        )}
        {setBulkUploadModal && (
          <button
            className="btn btn-secondary btn-rounded me-4"
            onClick={() => setBulkUploadModal(true)}
          >
            Add Bulk Data
          </button>
        )}
        {canExport && handleExportData && (
          <button
            className="btn btn-secondary btn-rounded"
            onClick={() => handleExportData()}
          >
            Export Test Master
          </button>
        )}
        {handleSearch && (
          <div className="ms-auto d-inline-flex me-3 d-flex align-items-center justify-content-center gap-3">
            <div className="input-group search-area">
              <input
                type="text"
                className="form-control"
                placeholder="Search here"
                value={searchValue}
                onChange={handleSearch}
              />
              <div className="input-group-append">
                <button type="button" className="input-group-text">
                  <FaSearch />
                </button>
              </div>
            </div>
            <OverlayTrigger
              trigger={["hover", "focus"]}
              placement={"auto"}
              responsive={true}
              overlay={
                <Tooltip className="d-flex align-items-center justify-content-center">
                  <p
                    className="popover-header"
                    style={{ marginBottom: "0rem" }}
                  >
                    Go To The Trash File
                  </p>
                </Tooltip>
              }
            >
              {showPaymentStatusTab ? (
                <div
                  className={styles.trash}
                  onClick={async () => await dispatch(setPaymentStatus(3))}
                >
                  <FaTrashCan />
                </div>
              ) : (
                <div
                  className={styles.trash}
                  onClick={async () => await dispatch(globalStatusChange(3))}
                >
                  <FaTrashCan />
                </div>
              )}
            </OverlayTrigger>
          </div>
        )}
      </div>
      {/* {showPaymentStatusTab && <PaymentStatusTab />} */}

      {/* {!hideStatusTab && (
        <StatusTab
          hideStatusTab={hideStatusTab}
          showLimitDropdown={showLimitDropdown}
          limit={limit}
          onLimitChange={onLimitChange}
        />
      )} */}
      {/* If showPaymentStatusTab is true, show ONLY PaymentStatusTab. 
    Otherwise, check if standard tabs should be shown. */}
      {/* ActionButtons.jsx modification */}

      {showPaymentStatusTab ? (
        <PaymentStatusTab
          showLimitDropdown={showLimitDropdown}
          limit={limit}
          onLimitChange={onLimitChange}
        />
      ) : (
        <StatusTab
          hideStatusTab={hideStatusTab}
          showLimitDropdown={showLimitDropdown}
          limit={limit}
          onLimitChange={onLimitChange}
        />
      )}
    </>
  );
};

export default memo(ActionButtons);
